import React, {useState, useEffect} from 'react'
import { Button, Col, Row, ListGroup, ListGroupItem } from 'reactstrap'
import Modal from 'ui/modal'
import RelatedProducts from 'containers/purchase/partials/related_products'
import { useTranslation } from 'react-i18next'

const SummaryModal = (props) => {
  const {modal, endpoints, relatedProducts, cart, redirectUrl} = props
  const { t, i18n } = useTranslation()

  return (
    <Modal
      isOpen={modal}
      footer={() => {
        return (
          <React.Fragment>
            <Row>
              <Col>
                <Button
                  href={endpoints.products}
                  color="primary"
                  className="btn-block text-primary py-3 text-uppercase"
                  style={{background: 'transparent'}}
                >
                  <i className="fa fa-plus-square mr-2"/> {i18n.t('summary_modal.see_more_products')}
                </Button>
              </Col>

              <Col>
                <Button
                  href={redirectUrl}
                  color="primary"
                  className="btn-block text-white font-weight-bold py-3 text-uppercase"
                >
                  <i className="fa fa-caret-square-right mr-2"/> {i18n.t('cart_summary.link_to_reservation')}
                </Button>
              </Col>
            </Row>

            <div>
              <RelatedProducts
                products={relatedProducts}
                url={endpoints.service}
                limitProducts={3}
                rowProps={{
                  className: 'row-cols-1 row-cols-sm-2 row-cols-md-3 mt-3',
                  style: {justifyContent: 'center'}
                }}
              />
            </div>
          </React.Fragment>

        )
      }}
      width={850}
      showCloseIcon={false}
      bodyStyle={{padding: '35px'}}
    >
      {cart &&
        <ListGroup>
          <ListGroupItem className="bg-light font-weight-bold">
            <i className="fa fa-shopping-bag mr-2"/>{i18n.t('summary_module.title')}
          </ListGroupItem>
          {cart.items.map((item) => {
            const {id, product, total_price_label} = item

            return (
              <ListGroupItem key={id} className="d-flex justify-content-between">
                <div>
                  {product.title}
                </div>
                <div>
                  <strong>
                    {total_price_label}
                  </strong>
                </div>
              </ListGroupItem>
            )
          })}
          <ListGroupItem color="primary" className="d-flex justify-content-between font-weight-bold">
            <div>{i18n.t('summary_module.total_amount')}</div>
            <div>{cart.final_price_label}</div>
          </ListGroupItem>
        </ListGroup>
      }
    </Modal>
  )
}

export default SummaryModal
